module.exports = __webpack_public_path__ + "img/second-prize-cn.ebafb73.png";